import React, { useEffect, useState, useContext } from "react";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { IoArrowForwardCircle } from "react-icons/io5";
import MenuBar from "../MenuBar/MenuBar";
import { MenuBarContext } from "../../contexts/MenuBarContext";
import { RxHamburgerMenu } from "react-icons/rx";
import { MdOutlineCancel } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import { debounce } from "lodash";
import { navbarContent } from "../../data/Data";
<MenuBar />;
const Navbar = () => {
  const navigate = useNavigate();
  const { toggleMenu, isMenuOpen } = useContext(MenuBarContext);
  const [isServicesOpen, setServices] = useState(false);
  const [isWhyUsOpen, setWhyUsOpen] = useState(false);
  const [isuserUsOpen, setuserOpen] = useState(false);
  const [isMobUserOpen, setMobUserOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [touchTimer, setTouchTimer] = useState(null);

  function handleClick() {
    setServices((prevState) => {
      if (!prevState) {
        setWhyUsOpen(false);
      }
      return !prevState;
    });
    // setWhyUsOpen((prevState)=>(!prevState));
  }

  const handleWhyUs = () => {
    setWhyUsOpen((prevState) => {
      if (!prevState) {
        setServices(false);
      }
      return !prevState;
    });
  };

  const anchorCareLinks = () => {
    setWhyUsOpen(false);
    setServices(false);
  };

  const handleUser = () => {
    setuserOpen((prevState) => {
      if (!prevState) {
        setServices(false);
        setWhyUsOpen(false);
      }
      return !prevState;
    });
  };

  const handleMenuClick = () => {
    toggleMenu();
  };

  // Debounced function to handle touch start
  const handleTouchStart = debounce(() => {
    setProfileOpen(true);
  }, 100); // Debounce delay for touch start

  // Handle touch end with a delay
  const handleTouchEnd = () => {
    if (touchTimer) clearTimeout(touchTimer); // Clear any existing timer
    const newTimer = setTimeout(() => {
      setProfileOpen(false);
    }, 3000); // 3 seconds delay before closing
    setTouchTimer(newTimer);
  };

  // Handle mouse enter
  const handleMouseEnter = () => {
    if (touchTimer) clearTimeout(touchTimer); // Clear any existing touch timer
    setProfileOpen(true);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest(".dropdown")) {
      setProfileOpen(false);
      setMobUserOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // Handle mouse leave
  const handleMouseLeave = () => {
    if (touchTimer) clearTimeout(touchTimer); // Clear any existing touch timer
    const newTimer = setTimeout(() => {
      setProfileOpen(false);
    }, 3000); // 3 seconds delay before closing
    setTouchTimer(newTimer);
  };

  return (
    <nav className="top-0 fixed z-50 shadow-md w-full bg-basecolor font-basefont ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <div className="flex justify-between w-full items-center h-16">
          <div className="flex items-center  cursor-pointer">
            <p
              onClick={() => navigate(`${process.env.PUBLIC_URL}/`)}
              className="flex items-center">
              <img src={logo} className="mr-3 lg:h-16 h-12" alt=" Logo" />
              <span className="self-center  text-white font-basefont lg:text-xl text-sm font-semibold whitespace-nowrap">
                PG Overseas Services
              </span>
            </p>
          </div>

          <div className="flex space-x-5  md:flex hidden">
            <p
              className="text-md font-medium text-white cursor-pointer hover:text-lightcolor"
              onClick={() => navigate(`${process.env.PUBLIC_URL}/home`)}
            >
              Home
            </p>
            <div
              className="text-md  font-medium text-white   cursor-pointer hover:text-lightcolor flex items-center"
              onClick={handleClick}
            >
              Services{" "}
              <span className="gap-2 text-xl">
                {isServicesOpen ? <MdArrowDropUp /> : <MdArrowDropDown />}
              </span>{" "}
            </div>

            <p
              className="text-md font-medium  text-white  cursor-pointer hover:text-lightcolor"
              onClick={() => navigate(`${process.env.PUBLIC_URL}/about`)}
            >
              About us
            </p>

            <p
              className="text-md font-medium text-white  cursor-pointer hover:text-lightcolor"
              onClick={() => navigate(`${process.env.PUBLIC_URL}/testimonials`)}
            >
              Testimonials
            </p>

         
            <p
              onClick={() => navigate(`${process.env.PUBLIC_URL}/contact`)}
              className="text-md font-medium text-white  pr-10 border-gray-600 cursor-pointer hover:text-lightcolor"
            >
              Contact us
            </p>
          </div>

          <button
            className="md:hidden block h-12 w-12 rounded-md p-3 text-white"
            onClick={handleMenuClick}
          >
            {isMenuOpen ? (
              <MdOutlineCancel className="h-6 w-6" />
            ) : (
              <RxHamburgerMenu />
            )}
          </button>
        </div>
      </div>

      {isServicesOpen && (
        <div className="absolute left-1/2 -translate-x-1/2 top-full z-50 mt-1 rounded-md bg-white shadow-xl w-[700px] p-6 md:block hidden">
          <div className="grid grid-cols-2 gap-3">
            {navbarContent?.map((item, idx) => (
              <div
                key={idx}
                onClick={() => {
                  setServices(false);
                  navigate({
                    pathname: `${process.env.PUBLIC_URL}${item?.url}`,
                  });
                }}
                className="flex items-start space-x-4 cursor-pointer hover:bg-gray-50 hover:border-basecolor hover:border p-2 rounded-md"
              >
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-basecolor flex items-center justify-center text-white text-sm font-bold">
                  {item?.title?.charAt(0)}
                </div>

                <div className="flex flex-col">
                  <span className="text-base font-semibold mt-1 text-gray-900">
                    {item?.title}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
